import { useRef, useState } from 'react'
import { ChatInput } from './chat-input'
import type { ResolvedComposerConfig } from '@/types/composer'

interface MobileAgentComposerProps {
  draftRef: { current: string }
  composerConfig: ResolvedComposerConfig
  clientName: string
  isLoading: boolean
  onSend: (message: string) => boolean
  onOpen: () => void
}

/** The mini and full composers share a draft; accepted sends are cleared before opening. */
export function MobileAgentComposer({ draftRef, composerConfig, clientName, isLoading, onSend, onOpen }: MobileAgentComposerProps) {
  const [text, setText] = useState(draftRef.current)
  const submitted = useRef(false)
  const submit = () => {
    if (submitted.current || isLoading || !text.trim()) return
    submitted.current = true
    const accepted = onSend(text)
    if (accepted) {
      draftRef.current = ''
      setText('')
      onOpen()
    } else {
      submitted.current = false
    }
  }
  return (
    <ChatInput mini onMiniFocus={onOpen} inputText={text} setInputText={(value) => {
      draftRef.current = value
      setText(value)
    }} onSubmit={submit} composerConfig={composerConfig} clientName={clientName} isLoading={isLoading} />
  )
}
